import { PureComponent } from "react";

import { TriggerButton } from "widgets";

import { TableExportDialog } from "./TableExportDialog.js";
import { PopOverActionWidget } from "./overlays/index.js";
import { type Organism } from "@/graphql.ts";
import { type ITableData } from "@/redux/modules/table-data.ts";
import { ENTITY_TYPE, VIEW } from "@/settings/settings.js";

export interface ITableExportButtonProps {
  viewType: string;
  tables: ITableData[];
  summaryPageEntity: { id: number; groupType: string };
  forceDisabled: boolean;
  getParentEntityName?: () => string;
}

class TableExportButton extends PureComponent<ITableExportButtonProps> {
  getDisabledTooltipText = () => {
    const tables = this.props.tables;
    const isTableView: boolean = this.props.viewType === VIEW.TABLE_VIEW.type;
    const isSummaryView: boolean = this.props.viewType === VIEW.ENTITY_SUMMARY_VIEW.type;

    if (this.props.forceDisabled || (isTableView && !tables?.find((table: ITableData) => table.filteredRowCount > 0))) {
      // ... or table is empty
      return "At least one row must be selected to perform an export";
    } else if (
      isSummaryView &&
      this.props.summaryPageEntity &&
      this.props.summaryPageEntity.groupType === ENTITY_TYPE.ORGANISM &&
      !(this.props.summaryPageEntity as Organism).sequenced
    ) {
      return "Genome is not sequenced and cannot be exported";
    }
  };

  render() {
    const buttonDisabledTooltip = this.getDisabledTooltipText();

    return (
      <PopOverActionWidget
        title={"Export"}
        actionWidget={({ open }) => (
          <TriggerButton
            icon={"cloud_download"}
            onPress={() => open()}
            isDisabled={buttonDisabledTooltip}
            label={"Export"}
            showLabel
          />
        )}
      >
        {({ close }) => (
          <TableExportDialog
            viewType={this.props.viewType}
            tables={this.props.tables}
            summaryPageEntity={this.props.summaryPageEntity}
            close={close}
            getParentEntityName={this.props.getParentEntityName}
          />
        )}
      </PopOverActionWidget>
    );
  }
}

export default TableExportButton;
